"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Separator = void 0;
var _mui = require("@ori-ui/mui");
var _constants = require("../constants");
const Separator = exports.Separator = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'none',
  boxSizing: 'border-box',
  overflow: 'hidden',
  height: 1,
  width: '100%',
  background: theme.palette.grey[200],
  [`&:has(+ .${_constants.BASKET_ITEM_IDENTIFIER})`]: {
    display: 'block'
  }
}));
